/**
 * @generated SignedSource<<4ad01f31f9d8510c10c9866628c2151a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PullRequestPickerPullRequest$data = {
  readonly __typename: "PullRequest";
  readonly createdAt: string;
  readonly id: string;
  readonly isDraft: boolean;
  readonly number: number;
  readonly repository: {
    readonly id: string;
    readonly name: string;
    readonly nameWithOwner: string;
    readonly owner: {
      readonly __typename: string;
      readonly login: string;
    };
  };
  readonly state: PullRequestState;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "PullRequestPickerPullRequest";
};
export type PullRequestPickerPullRequest$key = {
  readonly " $data"?: PullRequestPickerPullRequest$data;
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestPickerPullRequest">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PullRequestPickerPullRequest"
};

(node as any).hash = "cc9bf27660d5ef8b3ec703cf67a15790";

export default node;
